"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Table = Table;
exports.TableBody = TableBody;
exports.TableCaption = TableCaption;
exports.TableCell = TableCell;
exports.TableFooter = TableFooter;
exports.TableHead = TableHead;
exports.TableHeader = TableHeader;
exports.TableRow = TableRow;
var React = _interopRequireWildcard(require("react"));
var _utils = require("@design/lib/utils");
var _truncatedText = require("@design/ui/truncated-text");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className"],
  _excluded2 = ["className"],
  _excluded3 = ["className"],
  _excluded4 = ["className"],
  _excluded5 = ["className"],
  _excluded6 = ["className"],
  _excluded7 = ["className", "children"],
  _excluded8 = ["className"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function Table(_ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    "data-slot": "table-container",
    className: "relative w-full overflow-x-auto",
    "data-sentry-component": "Table",
    "data-sentry-source-file": "table.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("table", _objectSpread({
      "data-slot": "table",
      className: (0, _utils.cn)("w-full caption-bottom text-sm", className)
    }, props))
  });
}
function TableHeader(_ref2) {
  var className = _ref2.className,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("thead", _objectSpread(_objectSpread({
    "data-slot": "table-header",
    className: (0, _utils.cn)("[&_tr]:border-b", className)
  }, props), {}, {
    "data-sentry-component": "TableHeader",
    "data-sentry-source-file": "table.tsx"
  }));
}
function TableBody(_ref3) {
  var className = _ref3.className,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("tbody", _objectSpread(_objectSpread({
    "data-slot": "table-body",
    className: (0, _utils.cn)("[&_tr:last-child]:border-0", className)
  }, props), {}, {
    "data-sentry-component": "TableBody",
    "data-sentry-source-file": "table.tsx"
  }));
}
function TableFooter(_ref4) {
  var className = _ref4.className,
    props = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("tfoot", _objectSpread(_objectSpread({
    "data-slot": "table-footer",
    className: (0, _utils.cn)("border-t bg-muted/50 font-medium [&>tr]:last:border-b-0", className)
  }, props), {}, {
    "data-sentry-component": "TableFooter",
    "data-sentry-source-file": "table.tsx"
  }));
}
function TableRow(_ref5) {
  var className = _ref5.className,
    props = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("tr", _objectSpread(_objectSpread({
    "data-slot": "table-row",
    className: (0, _utils.cn)("border-b transition-colors hover:bg-muted/50 has-aria-expanded:bg-muted/50 data-[state=selected]:bg-muted", className)
  }, props), {}, {
    "data-sentry-component": "TableRow",
    "data-sentry-source-file": "table.tsx"
  }));
}
function TableHead(_ref6) {
  var className = _ref6.className,
    props = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("th", _objectSpread(_objectSpread({
    "data-slot": "table-head",
    className: (0, _utils.cn)("h-(--component-base-head-height) px-(--component-base-cell-padding) text-left align-middle font-medium whitespace-nowrap text-foreground [&:has([role=checkbox])]:pr-0", className)
  }, props), {}, {
    "data-sentry-component": "TableHead",
    "data-sentry-source-file": "table.tsx"
  }));
}
function TableCell(_ref7) {
  var className = _ref7.className,
    children = _ref7.children,
    props = _objectWithoutProperties(_ref7, _excluded7);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("td", _objectSpread(_objectSpread({
    "data-slot": "table-cell",
    className: (0, _utils.cn)("p-(--component-base-cell-padding) align-middle whitespace-nowrap [&:has([role=checkbox])]:pr-0", className)
  }, props), {}, {
    "data-sentry-component": "TableCell",
    "data-sentry-source-file": "table.tsx",
    children: (0, _truncatedText.truncateTextChildren)(children)
  }));
}
function TableCaption(_ref8) {
  var className = _ref8.className,
    props = _objectWithoutProperties(_ref8, _excluded8);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("caption", _objectSpread(_objectSpread({
    "data-slot": "table-caption",
    className: (0, _utils.cn)("mt-4 text-sm text-muted-foreground", className)
  }, props), {}, {
    "data-sentry-component": "TableCaption",
    "data-sentry-source-file": "table.tsx"
  }));
}